import {useFormik} from 'formik';
import {useSchemes} from '../../../shared/lib/validation';
import {setSessionItem} from '../../../shared/lib';
import {useAuth} from '../../../entities/auth/hooks/useAuth';

export const useIdentifierForm = () => {
  const {identifierSchema} = useSchemes();
  const {isInitFlowLoading} = useAuth();

  const handleSubmit = async () => {
    setSessionItem('auth_identifier', formik.values.identifier);
  };

  const formik = useFormik({
    initialValues: {
      identifier: '',
    },
    validationSchema: identifierSchema,
    onSubmit: handleSubmit,
  });

  return {
    ...formik,
    isInitFlowLoading,
  };
};
